import { StyledBadge } from './Badge.styles';
import type { BadgeProps } from './Badge.types';

export const Badge = ({ tone = 'sale', children, ...props }: BadgeProps) => (
  <StyledBadge data-tone={tone} {...props}>
    {children}
  </StyledBadge>
);
